import React from 'react';
import {
  ApplicationIcon,
  Box,
  ButtonIcon,
  Icon,
  Typography,
} from '@saviynt/design-system';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import BreadCrumb from '../../BreadCrumb';

import './CarouselHeader.css';

function CarouselHeader({
  header,
  headerClassName,
  breadCrumb,
  breadCrumbOnClick,
  onClick,
  dataTestId,
}) {
  const headerClasses = classnames('Carousel-header', headerClassName);
  const shouldRenderBreadCrumb = Boolean(
    Array.isArray(breadCrumb) && breadCrumb.length > 1
  );

  const getHeaderDescription = () => {
    const isString = typeof header?.description === 'string';
    const isElement = React.isValidElement(header?.description);

    if (isString) {
      return (
        <Typography
          kind='body3'
          desktop='body3-d'
          mobile='body3-d'
          lineLimit={1}>
          {header.description}
        </Typography>
      );
    }

    if (isElement) {
      return (
        <Box tag='div' className='Carousel-headerDescription'>
          {header?.description}
        </Box>
      );
    }

    return null;
  };

  return (
    <div className={headerClasses}>
      <div className='Carousel-headerContents'>
        {shouldRenderBreadCrumb && (
          <BreadCrumb data={breadCrumb} onPrevClicked={breadCrumbOnClick} />
        )}

        <div className='Carousel-headerTextIconGroup'>
          {header.icon && <ApplicationIcon logo={header.icon} size='large' />}
          <div className='Carousel-headerText'>
            {header.title && (
              <Typography
                kind='h3'
                color='--color-foreground-neutral-bold'
                lineLimit={2}
                tooltipConfigs={{ openDelay: 500 }}>
                {header.title}
              </Typography>
            )}
            {getHeaderDescription()}
          </div>
        </div>
      </div>
      <ButtonIcon
        id='Carousel-closeButton'
        size='medium'
        kind='ghost'
        icon={<Icon kind='close' color='neutral-100' size='medium' />}
        onClick={onClick}
        dataTestId={dataTestId}
      />
    </div>
  );
}

CarouselHeader.propTypes = {
  header: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    icon: PropTypes.string,
  }),
  headerClassName: PropTypes.string,
  breadCrumb: PropTypes.arrayOf(PropTypes.shape({})),
  breadCrumbOnClick: PropTypes.func,
  onClick: PropTypes.func,
  dataTestId: PropTypes.string,
};

CarouselHeader.defaultProps = {
  header: {
    title: '',
    description: '',
    icon: null,
  },
  headerClassName: '',
  breadCrumb: [],
  breadCrumbOnClick: () => {},
  onClick: () => {},
  dataTestId: 'CarouselHeader-testId',
};

export default CarouselHeader;
